<div id="app-toolbar">
    <button
        pButton
        type="button"
        class="p-button-secondary p-button-text nav-btn"
        id="nav-btn-user"
        #navBtnUser
        (click)="profileMenu.toggle($event)">
        <span>
            <p id="nav-current-user-name">{{ currentUser?.shortName }}</p>
            <p id="nav-current-user-role" *ngIf="currentUser?.role === roles.ADMIN">ADMIN</p>
        </span>
        <span id="user-avatar-container">
            <app-user-avatar></app-user-avatar>
        </span>
    </button>

    <p-overlayPanel #profileMenu [styleClass]="'action-item-menu-user'" class="action-item-menu" [focusOnShow]="true">
        <app-menu-profile
            (closePopover)="profileMenu.toggle(false); navBtnUser.focus()"
            (mouseleave)="hideOverlay()"></app-menu-profile>
    </p-overlayPanel>
</div>
